
import { Route, Routes } from 'react-router';
import PageHeader from "../components/Header/index";
import PageFooter from "../components/Footer/index";

import * as routeConfig from "../config/routeConfig";
import HomePageComponent from '../../containers/home-page';
import TermsConditions from '../../containers/terms-conditions/terms-conditions';
import RefundPolicy from '../../containers/terms-conditions/refund-policy';
import PrivacyPolicy from '../../containers/terms-conditions/privacy-policy';
import EVHomeComponent from '../../containers/ev-home-page';
const routes = (
  <div>
     <PageHeader />
    <Routes>
      <Route path="/" element={<HomePageComponent />} />
      <Route path="/ev" element={<EVHomeComponent />} />
      <Route path={routeConfig.globalRoutes.terms} element={<TermsConditions />} />
      <Route path={routeConfig.globalRoutes.refund} element={<RefundPolicy />} />
      <Route path={routeConfig.globalRoutes.privacy} element={<PrivacyPolicy />} />
    </Routes>
    <PageFooter />
  </div>
);

export default routes